import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useRef, useState } from "react";
import ConfirmationDialog from "../../../sharedComponents/dialog/ConfirmationDialog";
import PlayerCard from "./PlayerCard";
import SearchBar from "./SearchBar";

const PlayerList = ({
  playerData,
  participants,
  addParticipant,
  playerNameSearchText,
  searchPlayerOrCollegeName,
  commonEventList,
  eventRosterID,
  setEventRosterID,
  eventDetails,
  setParticipants,
  editMode,
  handleSelectAllParticipant,
}) => {
  const [openConfirmEventChangeDialog, setOpenConfirmEventChangeDialog] =
    useState(false);
  const ref = useRef(null);

  // Handle changes for search input
  const handleSearchChange = (e) => searchPlayerOrCollegeName(e.target.value);
  const handleClearSearch = () => searchPlayerOrCollegeName("");

  // Handle radio button change for event selection
  const handleRadioBtnChange = (event) => {
    const newEventRosterID = event.target.value;
    const prevEventRosterID = String(eventDetails?.participantEventId).slice(4);

    if (participants?.length > 0) {
      ref.current = newEventRosterID;
      setOpenConfirmEventChangeDialog(true);
      return;
    }

    if (prevEventRosterID && editMode && participants?.length > 0) {
      if (prevEventRosterID !== newEventRosterID) {
        ref.current = newEventRosterID;
        setOpenConfirmEventChangeDialog(true);
      }
      return;
    }

    setEventRosterID(newEventRosterID);
  };

  // Confirmation dialog agree handler
  const onConfirmEventChangeEventAgree = () => {
    setParticipants([]);
    setEventRosterID(ref.current);
    setOpenConfirmEventChangeDialog(false);
  };

  // Confirmation dialog disagree handler
  const onConfirmEventChangeEventDisAgree = () => {
    ref.current = null;
    setOpenConfirmEventChangeDialog(false);
  };

  return (
    <>
      <Grid container rowSpacing={1} sx={{ backgroundColor: "#fff", p: 2 }}>
        <Grid item lg={8} md={8} sm={12} xs={12}>
          <RadioGroup row value={eventRosterID} onChange={handleRadioBtnChange}>
            {commonEventList?.map((event) => (
              <FormControlLabel
                key={event.leagueId}
                value={event.leagueId}
                control={<Radio />}
                label={event.eventName}
              />
            ))}
          </RadioGroup>
        </Grid>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={2}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={participants.length === playerData.length}
                  onChange={(e) => handleSelectAllParticipant(e.target.checked)}
                />
              }
              label="Select All"
            />
            <SearchBar
              label="Search Player"
              value={playerNameSearchText}
              onChange={handleSearchChange}
              onClear={handleClearSearch}
            />
          </Box>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Grid container spacing={1} columns={12}>
            {playerData.map((elem, i) => (
              <Grid key={i} item lg={2} md={4} sm={12} xs={12}>
                <PlayerCard
                  elem={elem}
                  participants={participants}
                  addParticipant={addParticipant}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      <ConfirmationDialog
        open={openConfirmEventChangeDialog}
        message="You have already selected participants for another event. Proceeding will remove them. Are you sure?"
        handleClose={() => setOpenConfirmEventChangeDialog(false)}
        handleAgree={onConfirmEventChangeEventAgree}
        handleDisAgree={onConfirmEventChangeEventDisAgree}
        maxWidth="md"
        paperStyle={{ width: "30%" }}
      />
    </>
  );
};

export default PlayerList;
